import { render, staticRenderFns } from "./ReleaseNoteForm.vue?vue&type=template&id=8a5495c4&"
import script from "./ReleaseNoteForm.vue?vue&type=script&lang=ts&"
export * from "./ReleaseNoteForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports